// 1st Party
import { validationEnableButton } from './validation';
import { quote } from './elements';

// https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
//
// This sample uses the Autocomplete widget to help the user select a
// place, then it retrieves the address components associated with that
// place, and then it populates the form fields with those details.
// This sample requires the Places library. Include the libraries=places
// parameter when you first load the API. For example:
// <script
// src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">

var autocompletePropertyAddress,
    autocompleteMailingAddress,
    autocompleteStreetAddress;

var componentForm = {
    street_number: 'short_name',
    // Street
    route: 'long_name',
    // City
    locality: 'long_name',
    // State
    administrative_area_level_1: 'short_name',
    // County
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    // Zip Code 5
    postal_code: 'short_name',
    // Zip Code 4
    postal_code_suffix: 'short_name'
};

var addressForm = {
    street_number: '',
    route: '',
    locality: '',
    administrative_area_level_1: '',
    country: '',
    postal_code: ''
};

function initAutocomplete() {
    var propertyAddressFullAddress = document.getElementById('PropertyAddress_FullAddress');
    var insuredAddressFullAddress = document.getElementById('Insured_Address_FullAddress');
    var newQuotePropertyAddressStreetAddress = document.getElementById('PropertyAddress_StreetAddress');
    var espanolQuoteFullAddress = document.getElementById('EspanolEmail_FullAddress');

    if (propertyAddressFullAddress) {
        // Create the autocomplete object, restricting the search predictions to
        // geographical location types.
        autocompletePropertyAddress = new google.maps.places.Autocomplete(
            propertyAddressFullAddress, { types: ['geocode'] });
        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components.
        autocompletePropertyAddress.setFields(['address_component']);
        // When the user selects an address from the drop-down, populate the
        // address fields in the form.
        autocompletePropertyAddress.addListener('place_changed', fillInPropertyAddress);
    }

    if (insuredAddressFullAddress) {
        autocompleteMailingAddress = new google.maps.places.Autocomplete(
            insuredAddressFullAddress, { types: ['geocode'] });
        autocompleteMailingAddress.setFields(['address_component']);
        autocompleteMailingAddress.addListener('place_changed', fillInMailingAddress);
    }

    if (newQuotePropertyAddressStreetAddress) {
        autocompleteStreetAddress = new google.maps.places.Autocomplete(
            newQuotePropertyAddressStreetAddress, { types: ['geocode'] });
        autocompleteStreetAddress.setFields(['address_component']);
        autocompleteStreetAddress.addListener('place_changed', fillInStreetAddress);
    }

    if (espanolQuoteFullAddress) {
        autocompleteStreetAddress = new google.maps.places.Autocomplete(
            espanolQuoteFullAddress, { types: ['geocode'] });
        autocompleteStreetAddress.setFields(['address_component']);
    }
}

function fillInPropertyAddress() {
    // Get the place details from the autocomplete object.
    var place = autocompletePropertyAddress.getPlace();
    fillInAddress(place, 'property', 'PropertyAddress_FullAddress');
    validationEnableButton({});
    quote.googleTypeAheadInput.val('true');
}

function fillInMailingAddress() {
    // Get the place details from the autocomplete object.
    var place = autocompleteMailingAddress.getPlace();
    fillInAddress(place, 'mailing', 'Insured_Address_FullAddress');
}

function fillInStreetAddress() {
    var place = autocompleteStreetAddress.getPlace();
    fillInAddress(place, 'property', 'PropertyAddress_StreetAddress', true);
}

function fillInAddress(place, idPrefix, autocompleteInputId, addressPage = false) {
    for (var component in componentForm) {
        let elem = document.getElementById(`${idPrefix}_${component}`);
        if (elem) {
            elem.value = '';
            elem.disabled = false;
        }
    }

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    for (var i = 0; i < place.address_components.length; i++) {

        var addressType = place.address_components[i].types[0];
        let elem = document.getElementById(`${idPrefix}_${addressType}`);

        if (componentForm[addressType] && elem) {
            let val = place.address_components[i][componentForm[addressType]];
            elem.value = val;
        }

        if (addressType in addressForm) {
            let val = place.address_components[i][componentForm[addressType]];
            addressForm[addressType] = val;
        }
    }

    if (idPrefix === 'property') {
        document.getElementById('property_route').value = `${addressForm.street_number} ${addressForm.route}`;
    } else if (idPrefix === 'mailing') {
        document.getElementById('mailing_route').value = `${addressForm.street_number} ${addressForm.route}`;
    }

    quote.googleTypeAheadInput.val('true');
    document.getElementById(autocompleteInputId).value = `${addressForm.street_number} ${addressForm.route}, ${addressForm.locality}, ${addressForm.administrative_area_level_1} ${addressForm.postal_code}`;

    if (addressPage) {
        document.getElementById(autocompleteInputId).value = `${addressForm.street_number} ${addressForm.route}`;
    }
}

window.initAutocomplete = initAutocomplete;